<template>
  <div>
    <v-toolbar color="blue-grey darken-2" dark dense>
      <v-icon left>inventory_2</v-icon>
      <v-toolbar-title>Envanter Ekranı</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon :loading="loading" @click="loadData">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <v-layout wrap class="inv-stats mt-3 px-2">
      <v-flex xs6 sm3 class="pr-2">
        <div class="inv-stat inv-stat--green">
          <div class="inv-stat-label">Toplam Has</div>
          <div class="inv-stat-value">{{ totalHas.toFixed(4) }} <span class="inv-stat-unit">gr</span></div>
        </div>
      </v-flex>
      <v-flex xs6 sm3 class="pr-2">
        <div class="inv-stat inv-stat--teal">
          <div class="inv-stat-label">Takı</div>
          <div class="inv-stat-value">{{ qtyByType(0) }} <span class="inv-stat-unit">adet</span></div>
        </div>
      </v-flex>
      <v-flex xs6 sm3 class="pr-2">
        <div class="inv-stat inv-stat--amber">
          <div class="inv-stat-label">Ziynet / Külçe</div>
          <div class="inv-stat-value">{{ qtyByType(1) + qtyByType(2) }} <span class="inv-stat-unit">adet</span></div>
        </div>
      </v-flex>
      <v-flex xs6 sm3>
        <div class="inv-stat inv-stat--grey">
          <div class="inv-stat-label">Kalem Çeşidi</div>
          <div class="inv-stat-value">{{ inventoryItems.length }}</div>
        </div>
      </v-flex>
    </v-layout>

    <v-data-table
      :headers="headers"
      :items="inventoryItems"
      :loading="loading"
      :rows-per-page-items="[50, 100, 500, { text: 'Tümü', value: -1 }]"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="px-2">{{ props.item.inventoryTypeName }}</td>
        <td class="px-2">
          {{ props.item.productName }}
          <span v-if="props.item.kulp" class="caption grey--text"> · {{ props.item.kulp }}</span>
          <span v-if="props.item.dateType" class="caption grey--text"> · {{ props.item.dateType }}</span>
        </td>
        <td class="px-2">{{ props.item.weight }}</td>
        <td class="px-2">{{ props.item.purityLabel }}</td>
        <td class="px-2">{{ props.item.size || '-' }}</td>
        <td class="px-2">{{ props.item.hasPerUnit.toFixed(4) }}</td>
        <td class="px-2">{{ props.item.quantity }}</td>
        <td class="px-2">{{ props.item.totalHas.toFixed(4) }}</td>
        <td class="px-2">
          <v-btn
            v-if="props.item.inventoryType === 0"
            small
            flat
            color="primary"
            @click="goToJewelryList(props.item)"
          >Liste</v-btn>
          <v-btn
            v-else
            small
            flat
            color="teal"
            @click="printBarcode(props.item)"
          >
            <v-icon small left>print</v-icon>
            Yazdır
          </v-btn>
        </td>
      </template>
    </v-data-table>

    <!-- Alt Butonlar -->
    <v-layout wrap justify-space-between class="mt-3 px-2">
      <v-flex xs12 md8>
        <div class="inv-actions">
          <v-btn color="amber darken-2" dark @click="openZiynetDialog" class="inv-btn ma-0">
            <v-icon left>monetization_on</v-icon>
            Ziynet Ekle
          </v-btn>
          <v-btn color="blue-grey darken-1" dark @click="openKulceDialog" class="inv-btn ma-0">
            <v-icon left>view_in_ar</v-icon>
            Külçe Ekle
          </v-btn>
          <v-btn color="teal darken-1" dark @click="openTakiDialog" class="inv-btn ma-0">
            <v-icon left>diamond</v-icon>
            Takı Ekle
          </v-btn>
          <v-btn color="brown darken-1" dark @click="openDigerDialog" class="inv-btn ma-0">
            <v-icon left>category</v-icon>
            Diğer Ekle
          </v-btn>
          <v-btn color="deep-purple darken-1" dark @click="openReceiveDialog" class="inv-btn ma-0">
            <v-icon left>move_to_inbox</v-icon>
            Girdiden Al
            <span v-if="receivePending.length" class="inv-btn-badge">{{ receivePending.length }}</span>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>

    <!-- ========== KÜLÇE EKLE DIALOG ========== -->
    <v-dialog v-model="kulceDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline blue-grey darken-1 white--text">
          <v-icon left color="white">view_in_ar</v-icon>
          Külçe Ekranı
        </v-card-title>
        <v-card-text class="pa-4">
          <v-combobox
            v-model="kulceForm.selectedProduct"
            :items="kulceProducts"
            item-text="label"
            item-value="id"
            label="Ürün"
            return-object
          ></v-combobox>
          <v-text-field
            :value="kulceForm.selectedProduct ? kulceForm.selectedProduct.weight + ' gr' : ''"
            label="Ağırlık"
            readonly
          ></v-text-field>
          <v-combobox
            v-model="kulceForm.selectedPurity"
            :items="kulcePurities"
            item-text="label"
            item-value="value"
            label="Ayar"
            return-object
          ></v-combobox>
          <v-text-field
            :value="kulceHas"
            label="Has"
            readonly
            suffix="gr"
          ></v-text-field>
          <v-text-field
            v-model.number="kulceForm.quantity"
            label="Adet"
            type="number"
          ></v-text-field>
          <v-select
            v-model="kulceForm.supplier"
            :items="supplierItems"
            item-text="label"
            item-value="key"
            label="Alındığı Tedarikçi (opsiyonel — mutabakat için Girdiden Al kullanın)"
            no-data-text="Önce Atölyeler / Rafineriler ekranından tanımlayın"
            return-object
            clearable
            @change="onSupplierChange(kulceForm)"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="kulceDialog = false">İptal</v-btn>
          <v-btn color="primary" dark :loading="kulceSaving" @click="saveKulce">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ========== ZİYNET EKLE DIALOG ========== -->
    <v-dialog v-model="ziynetDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline amber darken-2 white--text">
          <v-icon left color="white">monetization_on</v-icon>
          Ziynet Ekranı
        </v-card-title>
        <v-card-text class="pa-4">
          <v-combobox
            v-model="ziynetForm.selectedProduct"
            :items="ziynetProducts"
            item-text="label"
            item-value="name"
            label="Ürün"
            return-object
          ></v-combobox>
          <v-text-field
            :value="ziynetForm.selectedProduct ? ziynetForm.selectedProduct.weight + ' gr' : ''"
            label="Ağırlık"
            readonly
          ></v-text-field>
          <v-text-field
            :value="ziynetHas"
            label="Has"
            readonly
            suffix="gr"
          ></v-text-field>

          <!-- Kulp / Tarih varyantı -->
          <v-layout>
            <v-flex xs6 class="pr-2">
              <v-select
                v-model="ziynetForm.kulp"
                :items="['Kulplu', 'Kulpsuz']"
                label="Kulp"
              ></v-select>
            </v-flex>
            <v-flex xs6 class="pl-2">
              <v-select
                v-model="ziynetForm.dateType"
                :items="['Yeni', 'Eski']"
                label="Tarih"
              ></v-select>
            </v-flex>
          </v-layout>

          <!-- Tartı ile adet hesaplama -->
          <v-layout align-center class="mb-2">
            <v-flex>
              <v-text-field
                :value="ziynetWeighedTotal != null ? ziynetWeighedTotal + ' gr' : 'Tartılmadı'"
                label="Tartılan Toplam"
                readonly
                hide-details
              ></v-text-field>
            </v-flex>
            <v-btn
              color="teal"
              dark
              class="ml-3"
              :loading="ziynetScaleLoading"
              :disabled="!ziynetForm.selectedProduct"
              @click="readScaleForZiynet"
            >
              <v-icon left>fitness_center</v-icon>
              Tart
            </v-btn>
          </v-layout>

          <v-text-field
            v-model.number="ziynetForm.quantity"
            label="Adet"
            type="number"
            hint="Tart ile otomatik gelir; gerekirse düzenleyebilirsiniz."
            persistent-hint
          ></v-text-field>
          <v-select
            v-model="ziynetForm.supplier"
            :items="supplierItems"
            item-text="label"
            item-value="key"
            label="Alındığı Tedarikçi (opsiyonel — mutabakat için Girdiden Al kullanın)"
            no-data-text="Önce Atölyeler / Rafineriler ekranından tanımlayın"
            return-object
            clearable
            @change="onSupplierChange(ziynetForm)"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="ziynetDialog = false">İptal</v-btn>
          <v-btn color="primary" dark :loading="ziynetSaving" @click="saveZiynet">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ========== DİĞER EKLE DIALOG ========== -->
    <v-dialog v-model="digerDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline brown darken-1 white--text">
          <v-icon left color="white">category</v-icon>
          Diğer Kalem Ekle
        </v-card-title>
        <v-card-text class="pa-4">
          <v-select
            v-model="digerForm.selectedItem"
            :items="activeOtherItems"
            item-text="name"
            item-value="name"
            label="Kalem (Diğer Zimmet Kalemleri)"
            no-data-text="Önce 'Diğer Zimmet Kalemleri' ekranında tanımlayın"
            return-object
          ></v-select>
          <v-text-field
            v-model.number="digerForm.quantity"
            label="Adet"
            type="number"
          ></v-text-field>
          <v-select
            v-model="digerForm.supplier"
            :items="supplierItems"
            item-text="label"
            item-value="key"
            label="Alındığı Tedarikçi (opsiyonel — mutabakat için Girdiden Al kullanın)"
            no-data-text="Önce Atölyeler / Rafineriler ekranından tanımlayın"
            return-object
            clearable
            @change="onSupplierChange(digerForm)"
          ></v-select>
          <div class="caption grey--text">
            Listede yoksa: Envanter Yönetimi → Diğer Zimmet Kalemleri'nden ekleyin.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="digerDialog = false">İptal</v-btn>
          <v-btn color="primary" dark :loading="digerSaving" @click="saveDiger">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ========== TAKI EKLE DIALOG ========== -->
    <v-dialog v-model="takiDialog" max-width="900" persistent>
      <v-card>
        <v-card-title class="headline teal darken-1 white--text">
          <v-icon left color="white">diamond</v-icon>
          Takı Ekleme Ekranı
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeTakiDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <v-layout wrap>
            <!-- Sol: Form -->
            <v-flex xs12 md6 class="pr-3">
              <v-combobox
                v-model="takiForm.selectedProduct"
                :items="takiProducts"
                label="Ürün"
              ></v-combobox>
              <v-combobox
                v-model="takiForm.selectedSize"
                :items="takiSizes"
                label="Ölçü"
              ></v-combobox>
              <v-combobox
                v-model="takiForm.selectedPurity"
                :items="takiPurities"
                item-text="label"
                item-value="value"
                label="Ayar"
                return-object
              ></v-combobox>
              <v-select
                v-model="takiForm.supplier"
                :items="supplierItems"
                item-text="label"
                item-value="key"
                label="Alındığı Tedarikçi (opsiyonel — mutabakat için Girdiden Al kullanın)"
                no-data-text="Önce Atölyeler / Rafineriler ekranından tanımlayın"
                return-object
                clearable
                @change="onSupplierChange(takiForm)"
              ></v-select>
              <v-layout align-center>
                <v-flex grow>
                  <v-text-field
                    v-if="manualWeightMode && !takiForm.serialNumber"
                    :value="takiForm.weight"
                    label="Ağırlık (elle giriliyor)"
                    type="number"
                    step="0.0001"
                    min="0"
                    suffix="gr"
                    color="blue-grey"
                    @input="setManualWeight"
                  ></v-text-field>
                  <v-text-field
                    v-else
                    :value="takiForm.weight != null ? takiForm.weight + ' gr' : 'Tartım bekleniyor...'"
                    label="Ağırlık"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex shrink class="ml-2">
                  <v-btn v-if="!takiForm.serialNumber" small color="teal" dark @click="readScaleForTaki" :loading="scaleLoading">
                    <v-icon small left>fitness_center</v-icon>
                    Tartımı Oku
                  </v-btn>
                  <v-btn
                    v-if="manualWeightUnlocked && !takiForm.serialNumber"
                    small
                    :color="manualWeightMode ? 'blue-grey darken-2' : 'blue-grey'"
                    dark
                    @click="toggleManualWeight"
                  >
                    <v-icon small left>{{ manualWeightMode ? 'close' : 'edit' }}</v-icon>
                    {{ manualWeightMode ? 'Elle Girişi Kapat' : 'Elle Gir' }}
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-text-field
                :value="takiHas"
                label="Has"
                readonly
                suffix="gr"
              ></v-text-field>
              <div v-if="takiExpectedWeight" class="taki-expected" :class="{ 'taki-expected--warn': takiHasDeviation }">
                Girdideki birim <strong>has {{ Number(takiForm.expectedHasPerUnit).toFixed(4) }} gr</strong> —
                {{ takiForm.selectedPurity ? takiForm.selectedPurity.label : '' }} ayarda yaklaşık
                <strong>{{ takiExpectedWeight.toFixed(4) }} gr</strong> tartım bekleniyor<template v-if="manualWeightMode"> (has değerini değil, terazi ağırlığını yazın)</template>.
                <div v-if="takiHasDeviation">
                  Şu anki has {{ takiHas }} gr — girdiden {{ takiHasDeviation > 0 ? 'fazla' : 'eksik' }}
                  {{ Math.abs(takiHasDeviation).toFixed(4) }} gr. Bu farkla mutabakat Kısmi kalır.
                </div>
              </div>
              <div v-if="takiRoundingDifferenceText" class="subtitle-1 py-2" style="color: #00695c;">
                {{ takiRoundingDifferenceText }}
              </div>
              <v-text-field
                :value="takiForm.serialNumber || 'Kayıt sonrası oluşur'"
                label="Seri No"
                readonly
              ></v-text-field>
              <div v-if="takiForm.serialNumber" class="mt-2 pa-2 text-center taki-barcode-box">
                <div class="caption grey--text">Barkod</div>
                <barcode
                  class="taki-barcode-img"
                  :value="takiForm.serialNumber"
                  format="CODE128"
                  width="1.5"
                  :displayValue="false"
                />
                <div class="title font-weight-bold mt-1">{{ takiForm.serialNumber }}</div>
              </div>
            </v-flex>
            <!-- Sağ: Webcam -->
            <v-flex xs12 md6 class="pl-3">
              <div class="caption grey--text mb-1">Ürün Fotoğrafı</div>
              <webcam-capture
                v-if="takiDialog"
                ref="webcam"
                @captured="onPhotoCaptured"
              ></webcam-capture>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn v-if="takiForm.serialNumber" color="primary" @click="printTakiCertificate">
            <v-icon left>print</v-icon>
            Yazdır
          </v-btn>
          <template v-if="takiForm.serialNumber">
            <v-btn v-if="takiRemaining > 0" color="deep-purple darken-1" dark @click="startNextTaki">
              <v-icon left>add</v-icon>
              Bir Tane Daha Ekle ({{ takiRemaining }} kaldı)
            </v-btn>
            <v-btn color="teal" dark @click="closeTakiDialog">
              <v-icon left>check</v-icon>
              Kapat
            </v-btn>
          </template>
          <template v-else>
            <v-btn text color="grey" @click="closeTakiDialog">İptal</v-btn>
            <v-btn color="teal" dark :loading="takiSaving" :disabled="!takiForm.photoBase64 || takiForm.photoBase64.trim() === ''" @click="saveTaki">
              <v-icon left>save</v-icon>
              Kaydet
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ========== GİRDİDEN AL: GİRDİ SEÇİMİ ========== -->
    <v-dialog v-model="receiveListDialog" max-width="860" persistent>
      <v-card>
        <v-card-title class="headline deep-purple darken-1 white--text">
          <v-icon left color="white">move_to_inbox</v-icon>
          Girdiden Al — Bekleyen Girdiler
          <v-spacer></v-spacer>
          <v-btn icon dark @click="receiveListDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-layout wrap align-center class="mb-3">
            <v-flex shrink class="mr-3">
              <v-btn-toggle v-model="receiveFilterType" mandatory class="rcv-typetoggle">
                <v-btn flat small :value="0">Tümü</v-btn>
                <v-btn flat small :value="2">Rafineri</v-btn>
                <v-btn flat small :value="1">Atölye</v-btn>
              </v-btn-toggle>
            </v-flex>
            <v-flex style="max-width: 320px">
              <v-select
                v-model="receiveFilterSupplier"
                :items="receiveSupplierItems"
                item-text="label"
                item-value="key"
                label="Tedarikçi filtresi (tümü)"
                clearable
                hide-details
              ></v-select>
            </v-flex>
          </v-layout>
          <div v-if="receivePendingLoading" class="text-xs-center pa-4">
            <v-progress-circular indeterminate color="deep-purple"></v-progress-circular>
          </div>
          <div v-else-if="!receiveFilteredPending.length" class="text-xs-center pa-4 grey--text">
            Envantere alınmayı bekleyen girdi yok.
          </div>
          <div v-else>
            <div
              class="receive-card"
              :class="receiveCardClass(i.status)"
              v-for="i in receiveFilteredPending"
              :key="'rcv-' + i.id"
              @click="startReceive(i)"
            >
              <div class="receive-card-l">
                <div class="receive-line-title">
                  {{ i.supplierName }}
                  <span class="rcv-type" :class="i.supplierType === 1 ? 'rcv-type--ato' : 'rcv-type--raf'">
                    {{ i.supplierType === 1 ? 'Atölye' : 'Rafineri' }}
                  </span>
                </div>
                <div class="receive-line-meta">
                  {{ new Date(i.date).toLocaleDateString('tr-TR') }} ·
                  <span class="receive-chip" :class="statusChipClass(i.status)">{{ i.statusText }}</span>
                  · beklenen <span class="receive-has">{{ Number(i.expectedHas).toFixed(4) }}</span>
                  · kalan
                  <span class="receive-chip" :class="remainingChipClass(i.remainingHas)">{{ Number(i.remainingHas).toFixed(4) }}</span>
                  gr has
                </div>
                <div class="receive-card-items">{{ (i.items || []).map((x) => x.productName + ' x' + x.quantity).join(', ') || '—' }}</div>
              </div>
              <div class="receive-card-r">
                <v-btn color="deep-purple darken-1" dark class="receive-btn ma-0" @click.stop="startReceive(i)">Envantere Al</v-btn>
                <v-btn v-if="canCloseIntake" flat small color="red darken-1" class="ma-0 ml-2" title="Girdiyi mutabakat takibinden çıkar" @click.stop="openIntakeCloseDialog(i)">
                  <v-icon small left>lock</v-icon>
                  Kapat
                </v-btn>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="intakeCloseDialog" max-width="540" persistent>
      <v-card v-if="intakeCloseTarget">
        <v-card-title class="red darken-1 white--text">
          <v-icon left color="white">lock</v-icon>
          Girdiyi Elle Kapat
        </v-card-title>
        <v-card-text class="pa-4">
          <div class="body-2 mb-2">
            <strong>{{ intakeCloseTarget.supplierName }}</strong> —
            {{ new Date(intakeCloseTarget.date).toLocaleDateString('tr-TR') }} tarihli girdi
            <div class="mt-1 grey--text text--darken-1">
              Durum: {{ intakeCloseTarget.statusText }} ·
              beklenen {{ Number(intakeCloseTarget.expectedHas).toFixed(4) }} gr ·
              <template v-if="intakeCloseTarget.remainingHas > 0">
                eksik {{ Number(intakeCloseTarget.remainingHas).toFixed(4) }} gr
              </template>
              <template v-else-if="intakeCloseTarget.remainingHas < 0">
                fazla {{ Math.abs(Number(intakeCloseTarget.remainingHas)).toFixed(4) }} gr
              </template>
              <template v-else>fark yok</template>
            </div>
          </div>
          <v-alert :value="true" type="warning" outline class="mb-3">
            DİKKAT: Kapatılan girdi mutabakat takibinden çıkarılır — bu listede ve mutabakat toplamlarında
            bir daha görünmez. Eksik ya da fazla varsa mutabık kabul edilmiş sayılır. İşlem kayıt altına alınır;
            gerekirse Mutabakat Geçmişi ekranından "Geri Aç" ile geri alınabilir.
          </v-alert>
          <v-textarea v-model="intakeCloseNote" label="Kapatma sebebi" rows="2" counter="500" maxlength="500"></v-textarea>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn flat color="grey" :disabled="intakeClosing" @click="intakeCloseDialog = false">Vazgeç</v-btn>
          <v-btn color="red darken-1" dark :loading="intakeClosing" :disabled="!intakeCloseNote.trim()" @click="confirmIntakeClose">
            Evet, Kapat
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ========== GİRDİDEN AL: KABUL EKRANI ========== -->
    <v-dialog v-model="receiveDetailDialog" max-width="900" persistent>
      <v-card v-if="receiveIntake">
        <v-card-title class="headline deep-purple darken-1 white--text">
          <v-icon left color="white">move_to_inbox</v-icon>
          Envantere Al — {{ receiveIntake.supplierName }} · {{ new Date(receiveIntake.date).toLocaleDateString('tr-TR') }}
          <v-spacer></v-spacer>
          <v-btn icon dark @click="receiveDetailDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-3">
          <div class="receive-line" :class="{ 'receive-line--done': l.remaining === 0 }" v-for="(l, li) in receiveLines" :key="'rl-' + li">
            <v-layout wrap align-center>
              <v-flex xs12 sm3>
                <div class="receive-line-title">{{ l.sourceName }}</div>
                <div class="receive-line-meta">
                  Beklenen {{ l.expected }} ·
                  <span class="receive-chip" :class="l.remaining > 0 ? 'receive-chip--wait' : 'receive-chip--done'">kalan {{ l.remaining }}</span>
                  adet · birim has <span class="receive-has">{{ Number(l.hasPerUnit).toFixed(4) }}</span>
                </div>
              </v-flex>
              <v-flex xs6 sm2 class="px-2">
                <v-text-field
                  v-if="l.type !== 0"
                  v-model.number="l.qty"
                  label="Alınacak"
                  type="number"
                  min="0"
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm2 class="px-2">
                <v-select
                  v-if="l.type !== 0"
                  v-model="l.type"
                  :items="receiveTypeItems"
                  item-text="label"
                  item-value="value"
                  label="Tip"
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12 sm5 class="px-2">
                <v-layout v-if="l.type === 1" align-center>
                  <v-select v-model="l.ziynetProduct" :items="ziynetProducts" item-text="label" item-value="name" label="Ziynet Ürünü" return-object hide-details class="pr-2"></v-select>
                  <v-select v-model="l.kulp" :items="['Kulplu', 'Kulpsuz']" label="Kulp" hide-details class="pr-2" style="max-width:90px"></v-select>
                  <v-select v-model="l.dateType" :items="['Yeni', 'Eski']" label="Tarih" hide-details style="max-width:80px"></v-select>
                </v-layout>
                <v-layout v-else-if="l.type === 2" align-center>
                  <v-select v-model="l.kulceProduct" :items="kulceProducts" item-text="label" item-value="id" label="Külçe Ürünü" return-object hide-details class="pr-2"></v-select>
                  <v-select v-model="l.kulcePurity" :items="kulcePurities" item-text="label" item-value="value" label="Ayar" return-object hide-details style="max-width:110px"></v-select>
                </v-layout>
                <v-select v-else-if="l.type === 3" v-model="l.digerItem" :items="activeOtherItems" item-text="name" item-value="name" label="Diğer Kalem" return-object hide-details></v-select>
                <v-layout v-else-if="l.type === 0" align-center>
                  <span class="caption grey--text pr-2">Takı — tartım gerektiği için tek tek eklenir</span>
                  <v-btn small color="teal" dark @click="openTakiFromReceive(l)">Takı Ekle</v-btn>
                </v-layout>
                <span v-else class="caption red--text">Eşleşme bulunamadı — tip seçin</span>
              </v-flex>
            </v-layout>
            <div v-if="l.type !== 0 && l.qty > l.remaining" class="caption orange--text text--darken-2">
              Bu kalemden kalan {{ l.remaining }} adet — {{ l.qty }} alıyorsunuz, girdi "Fazla" durumuna düşecek.
            </div>
          </div>

          <div class="caption grey--text mt-2">
            <span v-if="hasReceivableLines">Alınan kalemler otomatik olarak bu girdiye bağlanır; has değerleri girdiden yazılır, mutabakat kendiliğinden güncellenir.</span>
            <span v-else>Bu girdide yalnızca takı kalemi var. Takılar tartım gerektirdiği için toplu alınamaz; yukarıdaki <strong>Takı Ekle</strong> ile tek tek eklenir ve girdiye kendiliğinden bağlanır.</span>
          </div>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="receiveDetailDialog = false" :disabled="receiveSaving">{{ hasReceivableLines ? 'Vazgeç' : 'Kapat' }}</v-btn>
          <v-btn v-if="hasReceivableLines" color="deep-purple darken-1" dark class="receive-btn" :loading="receiveSaving" @click="saveReceive">
            <v-icon left>move_to_inbox</v-icon>
            Envantere Al
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import WebcamCapture from "@/components/WebcamCapture.vue";
import VueBarcode from "vue-barcode";
import { readScaleWeight } from "@/utils/scaleSerial";
import apiSettings from "@/api/appSettings";

export default {
  components: { WebcamCapture, barcode: VueBarcode },
  data: () => ({
    loading: false,
    inventoryItems: [],
    totalHas: 0,
    headers: [
      { text: "Tip", value: "inventoryTypeName" },
      { text: "Ürün", value: "productName" },
      { text: "Ağırlık", value: "weight" },
      { text: "Ayar", value: "purityLabel" },
      { text: "Ölçü", value: "size" },
      { text: "Has", value: "hasPerUnit" },
      { text: "Adet", value: "quantity" },
      { text: "Toplam Has", value: "totalHas" },
      { text: "", value: "actions", sortable: false },
    ],

    // Külçe
    kulceDialog: false,
    kulceSaving: false,
    kulceForm: {
      selectedProduct: null,
      selectedPurity: null,
      quantity: 1,
      supplier: null,
      intake: null,
    },
    receivePending: [],
    receivePendingLoading: false,
    receiveListDialog: false,
    receiveDetailDialog: false,
    canCloseIntake: false,
    intakeCloseDialog: false,
    intakeCloseTarget: null,
    intakeCloseNote: "",
    intakeClosing: false,
    receiveIntake: null,
    receiveLines: [],
    receiveSaving: false,
    receiveFilterSupplier: null,
    receiveFilterType: 0,
    receiveTypeItems: [
      { label: "Ziynet", value: 1 },
      { label: "Külçe", value: 2 },
      { label: "Diğer", value: 3 },
    ],
    // Açılır liste tanımları envanter tanımları API'sinden yüklenir (loadDefinitions).
    kulceProducts: [],
    kulcePurities: [],

    // Ziynet
    ziynetDialog: false,
    ziynetSaving: false,
    ziynetScaleLoading: false,
    ziynetWeighedTotal: null,
    ziynetForm: {
      selectedProduct: null,
      kulp: "Kulpsuz",
      dateType: "Yeni",
      quantity: 1,
      supplier: null,
      intake: null,
    },
    ziynetProducts: [],

    // Takı
    takiDialog: false,
    takiSaving: false,
    scaleLoading: false,
    manualWeightUnlocked: false,
    manualWeightMode: false,
    manualWeightBuffer: "",
    takiForm: {
      selectedProduct: null,
      selectedSize: null,
      selectedPurity: null,
      weight: null,
      serialNumber: null,
      photoBase64: null,
      supplier: null,
      intake: null,
      expectedHasPerUnit: null,
    },
    takiRemaining: 0,
    takiProducts: [],
    takiSizes: [],
    takiPurities: [],
    hasFiyat: null,

    // Diğer
    digerDialog: false,
    digerSaving: false,
    digerForm: {
      selectedItem: null,
      quantity: 1,
      supplier: null,
      intake: null,
    },
    otherItems: [],
  }),

  computed: {
    hasReceivableLines() {
      return (this.receiveLines || []).some((l) => l.type !== 0);
    },
    // Envanter girişinde seçilecek tedarikçiler: atölyeler + rafineriler tek listede.
    // key = "<tip>-<id>"; tip 1=Atölye, 2=Rafineri (InventorySupplierType ile aynı).
    supplierItems() {
      const atolyeler = (this.$store.getters["atolye/atolyeler"] || []).map((a) => ({
        key: `1-${a.id}`, label: `Atölye: ${a.name}`, supplierType: 1, supplierId: a.id,
      }));
      const refineries = (this.$store.getters["refineries/refineries"] || []).map((r) => ({
        key: `2-${r.id}`, label: `Rafineri: ${r.name}`, supplierType: 2, supplierId: r.id,
      }));
      return [...atolyeler, ...refineries];
    },
    activeOtherItems() {
      return (this.otherItems || []).filter((o) => o.isActive);
    },
    qtyByTypeMap() {
      const map = {};
      (this.inventoryItems || []).forEach((i) => {
        map[i.inventoryType] = (map[i.inventoryType] || 0) + (Number(i.quantity) || 0);
      });
      return map;
    },
    refinerySupplierItems() {
      return (this.$store.getters["refineries/refineries"] || []).map((r) => ({
        label: r.name, supplierId: r.id,
      }));
    },
    receiveFilteredPending() {
      let liste = this.receivePending || [];
      if (this.receiveFilterType) liste = liste.filter((i) => i.supplierType === this.receiveFilterType);
      if (this.receiveFilterSupplier)
        liste = liste.filter((i) => i.supplierType + "-" + i.supplierId === this.receiveFilterSupplier);
      return liste;
    },
    receiveSupplierItems() {
      const gorulen = new Set();
      return (this.receivePending || [])
        .filter((i) => {
          const k = i.supplierType + "-" + i.supplierId;
          if (gorulen.has(k)) return false;
          gorulen.add(k);
          return !this.receiveFilterType || i.supplierType === this.receiveFilterType;
        })
        .map((i) => ({
          key: i.supplierType + "-" + i.supplierId,
          label: (i.supplierType === 1 ? "Atölye: " : "Rafineri: ") + i.supplierName,
        }));
    },
    kulceHas() {
      if (!this.kulceForm.selectedProduct || !this.kulceForm.selectedPurity) return "";
      const w = this.kulceForm.selectedProduct.weight;
      const p = this.kulceForm.selectedPurity.value;
      return (w * (p / 1000)).toFixed(4);
    },
    ziynetHas() {
      if (!this.ziynetForm.selectedProduct) return "";
      const w = this.ziynetForm.selectedProduct.weight;
      const p = this.ziynetForm.selectedProduct.purity;
      return (w * (p / 1000)).toFixed(4);
    },
    takiExpectedWeight() {
      const eh = Number(this.takiForm.expectedHasPerUnit);
      const p = this.takiForm.selectedPurity ? Number(this.takiForm.selectedPurity.value) : 0;
      if (!eh || !p) return null;
      return eh / (p / 1000);
    },
    takiHasDeviation() {
      const eh = Number(this.takiForm.expectedHasPerUnit);
      if (!eh || !this.takiHas) return null;
      const diff = Number(this.takiHas) - eh;
      if (Math.abs(diff) < Math.max(0.01, eh * 0.005)) return null;
      return diff;
    },
    takiHas() {
      if (!this.takiForm.weight || !this.takiForm.selectedPurity) return "";
      return (this.takiForm.weight * (this.takiForm.selectedPurity.value / 1000)).toFixed(4);
    },
    takiRoundingDifferenceText() {
      if (!this.takiForm.weight || !this.takiForm.selectedPurity || !this.hasFiyat || this.hasFiyat <= 0) return "";
      const w = parseFloat(this.takiForm.weight);
      const rounded = Math.round(w);
      const diffGr = rounded - w;
      if (Math.abs(diffGr) < 0.0001) return "";
      const p = this.takiForm.selectedPurity.value;
      const diffHas = diffGr * (p / 1000);
      const diffTl = (diffHas * this.hasFiyat).toFixed(2);
      return `Yuvarlama: ${w} gr → ${rounded} gr, fark ${diffGr.toFixed(2)} gr (has: ${diffHas.toFixed(4)}). Fark: ${diffTl} TL`;
    },
  },

  methods: {
    supplierPayload(supplier, intake) {
      if (!supplier || supplier.supplierType == null) {
        return { supplierType: 0, supplierId: 0 };
      }
      const payload = { supplierType: supplier.supplierType, supplierId: supplier.supplierId };
      if (intake && intake.id) {
        if (supplier.supplierType === 2) {
          payload.refineryIntakeId = intake.id;
          if (intake.itemId) payload.refineryIntakeItemId = intake.itemId;
        } else if (supplier.supplierType === 1) {
          payload.atolyeMovementId = intake.id;
          if (intake.itemId) payload.atolyeMovementItemId = intake.itemId;
        }
      }
      return payload;
    },
    onSupplierChange(form) {
      form.intake = null;
    },
    async loadReceivePending() {
      this.receivePendingLoading = true;
      try {
        this.receivePending = (await this.$store.dispatch("inventory/getOpenSupplierIntakes", {
          supplierType: 0,
          supplierId: 0,
        })) || [];
      } catch (e) {
        this.receivePending = [];
      } finally {
        this.receivePendingLoading = false;
      }
    },
    openIntakeCloseDialog(intake) {
      this.intakeCloseTarget = intake;
      this.intakeCloseNote = "";
      this.intakeCloseDialog = true;
    },
    async confirmIntakeClose() {
      if (!this.intakeCloseTarget || !this.intakeCloseNote.trim()) return;
      this.intakeClosing = true;
      try {
        await this.$store.dispatch("inventory/closeSupplierIntake", {
          supplierType: this.intakeCloseTarget.supplierType,
          id: this.intakeCloseTarget.id,
          note: this.intakeCloseNote.trim(),
        });
        this.intakeCloseDialog = false;
        this.$store.state.dialog = true;
        this.$store.state.message = "Girdi kapatıldı; mutabakat takibinden çıkarıldı.";
        await this.loadReceivePending();
        await this.loadData();
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Hata: " + (e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message);
      } finally {
        this.intakeClosing = false;
      }
    },
    openReceiveDialog() {
      this.receiveFilterSupplier = null;
      this.receiveFilterType = 0;
      this.receiveListDialog = true;
      this.loadReceivePending();
    },
    qtyByType(type) {
      return this.qtyByTypeMap[type] || 0;
    },
    normalizeName(v) {
      return (v || "").trim().toLocaleLowerCase("tr").replace(/\s+/g, " ");
    },
    statusChipClass(status) {
      if (status === 1) return "receive-chip--wait";
      if (status === 3) return "receive-chip--red";
      if (status === 2) return "receive-chip--done";
      return "receive-chip--grey";
    },
    receiveCardClass(status) {
      if (status === 1) return "receive-card--wait";
      if (status === 3) return "receive-card--red";
      if (status === 2) return "receive-line--done";
      return "receive-card--grey";
    },
    remainingChipClass(remaining) {
      const v = Number(remaining);
      if (v > 0.0001) return "receive-chip--wait";
      if (v < -0.0001) return "receive-chip--red";
      return "receive-chip--done";
    },
    guessReceiveTarget(name) {
      const n = this.normalizeName(name);
      const z = this.ziynetProducts.find((x) => this.normalizeName(x.label) === n);
      if (z) return { type: 1, ziynetProduct: z };
      const k = this.kulceProducts.find((x) => this.normalizeName(x.label) === n);
      if (k) return { type: 2, kulceProduct: k, kulcePurity: this.kulcePurities.length === 1 ? this.kulcePurities[0] : null };
      const d = this.activeOtherItems.find((x) => this.normalizeName(x.name) === n);
      if (d) return { type: 3, digerItem: d };
      const t = this.takiProducts.find((x) => this.normalizeName(x) === n);
      if (t) return { type: 0 };
      return { type: null };
    },
    startReceive(intake) {
      this.receiveIntake = intake;
      this.receiveLines = (intake.items || []).map((it) => {
        const g = this.guessReceiveTarget(it.productName);
        const remaining = it.remainingQuantity != null ? it.remainingQuantity : it.quantity;
        return {
          intakeItemId: it.id,
          sourceName: it.productName,
          expected: it.quantity,
          remaining,
          hasPerUnit: it.hasPerUnit,
          qty: g.type === 0 ? 0 : remaining,
          type: g.type,
          ziynetProduct: g.ziynetProduct || null,
          kulp: "Kulpsuz",
          dateType: "Yeni",
          kulceProduct: g.kulceProduct || null,
          kulcePurity: g.kulcePurity || null,
          digerItem: g.digerItem || null,
        };
      });
      this.receiveDetailDialog = true;
    },
    openTakiFromReceive(line) {
      const intakeId = this.receiveIntake ? this.receiveIntake.id : null;
      const supplierId = this.receiveIntake ? this.receiveIntake.supplierId : null;
      this.receiveDetailDialog = false;
      this.receiveListDialog = false;
      this.openTakiDialog();
      const tip = this.receiveIntake ? this.receiveIntake.supplierType : 2;
      const sup = this.supplierItems.find((x) => x.supplierType === tip && x.supplierId === supplierId);
      this.takiForm.supplier = sup || null;
      this.takiForm.intake = intakeId ? { id: intakeId } : null;
      if (line && line.sourceName) {
        const match = this.takiProducts.find((x) => this.normalizeName(x) === this.normalizeName(line.sourceName));
        this.takiForm.selectedProduct = match || line.sourceName;
      }
      if (line && line.intakeItemId && this.takiForm.intake) {
        this.takiForm.intake.itemId = line.intakeItemId;
      }
      this.takiRemaining = line && line.remaining != null ? line.remaining : 0;
      this.takiForm.expectedHasPerUnit = line && line.hasPerUnit != null ? line.hasPerUnit : null;
    },
    async saveReceive() {
      const lines = [];
      for (const l of this.receiveLines) {
        if (l.type === 0 || !l.qty || l.qty <= 0) continue;
        if (l.type == null) {
          this.$store.state.dialog = true;
          this.$store.state.message = `"${l.sourceName}" için tip seçin (Ziynet/Külçe/Diğer) ya da adedi 0 yapın.`;
          return;
        }
        if (l.type === 1) {
          if (!l.ziynetProduct) {
            this.$store.state.dialog = true;
            this.$store.state.message = `"${l.sourceName}" için ziynet ürünü seçin.`;
            return;
          }
          lines.push({ intakeItemId: l.intakeItemId, quantity: l.qty, inventoryType: 1, productName: l.ziynetProduct.name, kulp: l.kulp, dateType: l.dateType });
        } else if (l.type === 2) {
          if (!l.kulceProduct || !l.kulcePurity) {
            this.$store.state.dialog = true;
            this.$store.state.message = `"${l.sourceName}" için külçe ürünü ve ayar seçin.`;
            return;
          }
          lines.push({ intakeItemId: l.intakeItemId, quantity: l.qty, inventoryType: 2, productName: l.kulceProduct.label, weight: l.kulceProduct.weight, purity: l.kulcePurity.value, purityLabel: l.kulcePurity.label });
        } else if (l.type === 3) {
          if (!l.digerItem) {
            this.$store.state.dialog = true;
            this.$store.state.message = `"${l.sourceName}" için katalog kalemi seçin.`;
            return;
          }
          lines.push({ intakeItemId: l.intakeItemId, quantity: l.qty, inventoryType: 3, productName: l.digerItem.name });
        }
      }
      if (!lines.length) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Alınacak kalem yok (takı kalemleri tek tek eklenir).";
        return;
      }
      this.receiveSaving = true;
      try {
        const atolyeMi = this.receiveIntake.supplierType === 1;
        const res = await this.$store.dispatch("inventory/receiveIntake", {
          supplierType: this.receiveIntake.supplierType,
          refineryIntakeId: atolyeMi ? 0 : this.receiveIntake.id,
          atolyeMovementId: atolyeMi ? this.receiveIntake.id : 0,
          lines,
        });
        this.receiveDetailDialog = false;
        this.receiveListDialog = false;
        this.$store.state.dialog = true;
        this.$store.state.message = (res && res.message) || "Kalemler envantere alındı.";
        await Promise.all([this.loadData(), this.loadReceivePending()]);
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Envantere alma başarısız: " +
          ((e.response && e.response.data && e.response.data.message) || e.message || "bilinmeyen hata");
      } finally {
        this.receiveSaving = false;
      }
    },
    async loadSuppliers() {
      try {
        await Promise.all([
          this.$store.dispatch("atolye/getAtolyeler"),
          this.$store.dispatch("refineries/getRefineries"),
        ]);
      } catch (e) {
        // Tedarikçi listesi alınamazsa select boş kalır; kayıt sırasında uyarı verilir.
      }
    },
    // Envanter ekleme açılır listelerini (Takı/Külçe/Ziynet) tanım API'sinden yükler.
    async loadDefinitions() {
      try {
        const defs = (await this.$store.dispatch("inventory/getDefinitions")) || [];
        // Aynı etiket hem tenant'a özel hem ortak (tenant 0) olabilir → label bazında tekilleştir.
        const seenLabel = {};
        const pick = (type, cat) =>
          defs
            .filter((d) => d.inventoryType === type && d.category === cat && d.isActive)
            .filter((d) => {
              const k = `${type}|${cat}|${(d.label || "").trim().toLocaleLowerCase("tr")}`;
              if (seenLabel[k]) return false;
              seenLabel[k] = true;
              return true;
            });
        // type: 0=Takı,1=Ziynet,2=Külçe ; cat: 0=Ürün,1=Ölçü,2=Ayar
        this.takiProducts = pick(0, 0).map((d) => d.label);
        this.takiSizes = pick(0, 1).map((d) => d.label);
        this.takiPurities = pick(0, 2).map((d) => ({ label: d.label, value: d.value }));
        this.kulceProducts = pick(2, 0).map((d) => ({ id: d.id, label: d.label, weight: d.value }));
        this.kulcePurities = pick(2, 2).map((d) => ({ label: d.label, value: d.value }));
        this.ziynetProducts = pick(1, 0).map((d) => ({
          label: d.label,
          name: d.label,
          weight: d.value,
          purity: d.purity,
          purityLabel: d.purityLabel,
        }));
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("Envanter tanımları yüklenemedi:", e);
      }
    },
    async loadData() {
      this.loading = true;
      try {
        const [itemsRes, hasRes] = await Promise.all([
          this.$store.dispatch("inventory/getInventoryItems"),
          this.$store.dispatch("inventory/getTotalHas"),
        ]);
        this.inventoryItems = itemsRes;
        this.totalHas = hasRes;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Envanter yüklenemedi:", e);
      } finally {
        this.loading = false;
      }
    },

    goToJewelryList(item) {
      const query = {};
      if (item && item.productName) query.productName = item.productName;
      if (item && item.size) query.size = item.size;
      if (item && item.weight != null) query.weightRounded = item.weight; // 0,5'lik kova değeri (ör. 4.5)
      if (item && item.purity != null) query.purity = item.purity;
      if (item && item.purityLabel) query.purityLabel = item.purityLabel;
      this.$router.push({ path: "/admin/inventory/jewelry", query });
    },

    // Ziynet/Külçe tip barkodunu yazdır (barkod + ürün adı etiketi)
    printBarcode(item) {
      if (!item || !item.barcode) {
        this.$store.state.dialog = true;
        this.$store.state.message =
          "Bu ürün için barkod bulunamadı. Veritabanı güncellemesi (order_reading_migration.sql) çalıştırılmalı.";
        return;
      }
      const url =
        "/print/inventory-barcode?code=" + encodeURIComponent(item.barcode) +
        "&name=" + encodeURIComponent(item.productName || "");
      window.open(url, "_blank", "noopener,noreferrer");
    },

    // --- Külçe ---
    openKulceDialog() {
      this.kulceForm.intake = null;
      this.kulceDialog = true;
    },
    async saveKulce() {
      if (!this.kulceForm.selectedProduct || !this.kulceForm.selectedPurity
          || !Number.isFinite(this.kulceForm.quantity)) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Ürün ve ayar seçin; geçerli bir adet girin (negatif olabilir).";
        return;
      }
      const kulceSupplier = this.supplierPayload(this.kulceForm.supplier, this.kulceForm.intake);
      if (!kulceSupplier) return;
      this.kulceSaving = true;
      try {
        await this.$store.dispatch("inventory/addKulce", {
          productName: this.kulceForm.selectedProduct.label,
          weight: this.kulceForm.selectedProduct.weight,
          purity: this.kulceForm.selectedPurity.value,
          purityLabel: this.kulceForm.selectedPurity.label,
          quantity: this.kulceForm.quantity,
          ...kulceSupplier,
        });
        this.kulceDialog = false;
        this.kulceForm = { selectedProduct: null, selectedPurity: null, quantity: 1, supplier: null, intake: null };
        this.$store.state.dialog = true;
        this.$store.state.message = "Külçe başarıyla eklendi.";
        await this.loadData();
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Hata: " + (e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message);
      } finally {
        this.kulceSaving = false;
      }
    },

    // --- Ziynet ---
    openZiynetDialog() {
      this.ziynetForm = { selectedProduct: null, kulp: "Kulpsuz", dateType: "Yeni", quantity: 1, supplier: null, intake: null };
      this.ziynetWeighedTotal = null;
      this.ziynetDialog = true;
    },
    // Terazi okur ve seçili ziynetin birim ağırlığına bölerek adedi otomatik hesaplar.
    // Sadece tartar/hesaplar — stoğa EKLEMEZ (ekleme yalnızca "Kaydet" ile). Adet düzenlenebilir.
    async readScaleForZiynet() {
      if (!this.ziynetForm.selectedProduct) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Önce ürün seçin.";
        return;
      }
      this.ziynetScaleLoading = true;
      try {
        const data = await readScaleWeight({ requestPortIfNeeded: true });
        if (data.success) {
          this.ziynetWeighedTotal = data.weight;
          const unit = this.ziynetForm.selectedProduct.weight;
          if (unit > 0) {
            this.ziynetForm.quantity = Math.max(0, Math.round(data.weight / unit));
          }
        } else {
          this.$store.state.dialog = true;
          this.$store.state.message = data.message || "Teraziden veri okunamadı.";
        }
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = (e && e.message) || "Terazi bağlantı hatası. Chrome/Edge ve HTTPS (veya localhost) gerekir.";
      } finally {
        this.ziynetScaleLoading = false;
      }
    },
    async saveZiynet() {
      if (!this.ziynetForm.selectedProduct
          || !Number.isFinite(this.ziynetForm.quantity)) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Ürün seçin; geçerli bir adet girin (negatif olabilir).";
        return;
      }
      const ziynetSupplier = this.supplierPayload(this.ziynetForm.supplier, this.ziynetForm.intake);
      if (!ziynetSupplier) return;
      this.ziynetSaving = true;
      try {
        await this.$store.dispatch("inventory/addZiynet", {
          productName: this.ziynetForm.selectedProduct.name,
          kulp: this.ziynetForm.kulp,
          dateType: this.ziynetForm.dateType,
          quantity: this.ziynetForm.quantity,
          ...ziynetSupplier,
        });
        this.ziynetDialog = false;
        this.ziynetForm = { selectedProduct: null, kulp: "Kulpsuz", dateType: "Yeni", quantity: 1, supplier: null, intake: null };
        this.ziynetWeighedTotal = null;
        this.$store.state.dialog = true;
        this.$store.state.message = "Ziynet başarıyla eklendi.";
        await this.loadData();
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Hata: " + (e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message);
      } finally {
        this.ziynetSaving = false;
      }
    },

    // --- Diğer ---
    async openDigerDialog() {
      this.digerForm = { selectedItem: null, quantity: 1, supplier: null, intake: null };
      try {
        this.otherItems = (await this.$store.dispatch("inventory/getOtherItems")) || [];
      } catch (e) {
        this.otherItems = [];
      }
      this.digerDialog = true;
    },
    async saveDiger() {
      const name = this.digerForm.selectedItem
        ? (this.digerForm.selectedItem.name || this.digerForm.selectedItem)
        : null;
      if (!name || !Number.isFinite(this.digerForm.quantity)) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Kalem seçin; geçerli bir adet girin (negatif olabilir).";
        return;
      }
      const digerSupplier = this.supplierPayload(this.digerForm.supplier, this.digerForm.intake);
      if (!digerSupplier) return;
      this.digerSaving = true;
      try {
        await this.$store.dispatch("inventory/addDiger", {
          productName: name,
          quantity: this.digerForm.quantity,
          ...digerSupplier,
        });
        this.digerDialog = false;
        this.digerForm = { selectedItem: null, quantity: 1, supplier: null, intake: null };
        this.$store.state.dialog = true;
        this.$store.state.message = "Diğer kalem eklendi.";
        await this.loadData();
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Hata: " + (e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message);
      } finally {
        this.digerSaving = false;
      }
    },

    // --- Takı ---
    openTakiDialog() {
      this.takiForm = {
        selectedProduct: null,
        selectedSize: null,
        selectedPurity: null,
        weight: null,
        serialNumber: null,
        photoBase64: null,
        supplier: null,
        intake: null,
        expectedHasPerUnit: null,
      };
      this.takiRemaining = 0;
      this.manualWeightUnlocked = false;
      this.manualWeightMode = false;
      this.manualWeightBuffer = "";
      this.takiDialog = true;
    },
    startNextTaki() {
      this.takiForm.serialNumber = null;
      this.takiForm.weight = null;
      this.takiForm.photoBase64 = null;
      this.manualWeightUnlocked = false;
      this.manualWeightMode = false;
      this.manualWeightBuffer = "";
    },
    closeTakiDialog() {
      this.takiDialog = false;
      this.manualWeightUnlocked = false;
      this.manualWeightMode = false;
      this.manualWeightBuffer = "";
    },
    onManualWeightKey(e) {
      if (!this.takiDialog || this.manualWeightUnlocked) return;
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      const el = e.target;
      if (el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.isContentEditable)) return;
      if (!e.key || e.key.length !== 1) return;
      this.manualWeightBuffer = (this.manualWeightBuffer + e.key).toLocaleLowerCase("tr").slice(-16);
      if (this.manualWeightBuffer.includes("tartımıaç") || this.manualWeightBuffer.includes("tartimiac")) {
        this.manualWeightUnlocked = true;
        this.manualWeightBuffer = "";
      }
    },
    toggleManualWeight() {
      this.manualWeightMode = !this.manualWeightMode;
      if (!this.manualWeightMode) this.takiForm.weight = null;
    },
    setManualWeight(v) {
      const n = parseFloat(v);
      this.takiForm.weight = Number.isFinite(n) && n >= 0 ? n : null;
    },
    async readScaleForTaki() {
      this.scaleLoading = true;
      try {
        const data = await readScaleWeight({ requestPortIfNeeded: true });
        if (data.success) {
          this.takiForm.weight = data.weight;
        } else {
          this.takiForm.weight = 0;
          this.$store.state.dialog = true;
          this.$store.state.message = data.message || "Teraziden veri okunamadı.";
        }
      } catch (e) {
        this.takiForm.weight = 0;
        this.$store.state.dialog = true;
        this.$store.state.message = (e && e.message) || "Terazi bağlantı hatası.";
      } finally {
        this.scaleLoading = false;
      }
    },
    onPhotoCaptured(base64) {
      this.takiForm.photoBase64 = base64;
    },
    printTakiCertificate() {
      const photoSrc = this.takiForm.photoBase64
        ? "data:image/jpeg;base64," + this.takiForm.photoBase64
        : null;
      const certData = {
        productName: this.takiForm.selectedProduct,
        size: this.takiForm.selectedSize,
        weight: this.takiForm.weight,
        purityLabel: this.takiForm.selectedPurity ? this.takiForm.selectedPurity.label : null,
        serialNumber: this.takiForm.serialNumber,
        photoSrc,
      };
      localStorage.setItem("jewelryCertificateData", JSON.stringify(certData));
      window.open("/print/jewelry-certificate?template=classic", "_blank", "noopener,noreferrer");
    },
    async saveTaki() {
      if (!this.takiForm.selectedProduct || !this.takiForm.selectedSize ||
          !this.takiForm.selectedPurity || this.takiForm.weight == null) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Lütfen tüm alanları doldurun ve tartımı okuyun.";
        return;
      }
      if (!this.takiForm.photoBase64 || this.takiForm.photoBase64.trim() === "") {
        this.$store.state.dialog = true;
        this.$store.state.message = "Lütfen ürün fotoğrafı çekin.";
        return;
      }
      const takiSupplier = this.supplierPayload(this.takiForm.supplier, this.takiForm.intake);
      if (!takiSupplier) return;
      this.takiSaving = true;
      try {
        const result = await this.$store.dispatch("inventory/addTaki", {
          productName: this.takiForm.selectedProduct,
          size: this.takiForm.selectedSize,
          purity: this.takiForm.selectedPurity.value,
          purityLabel: this.takiForm.selectedPurity.label,
          weight: this.takiForm.weight,
          photoBase64: this.takiForm.photoBase64 || null,
          ...takiSupplier,
        });
        this.takiForm.serialNumber = result.serialNumber;
        if (this.takiRemaining > 0) this.takiRemaining -= 1;
        this.$store.state.dialog = true;
        this.$store.state.message = `Takı eklendi. Seri No: ${result.serialNumber}`;
        await this.loadData();
        // Dialog açık bırak ki seri no ve barkod görünsün
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Hata: " + (e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message);
      } finally {
        this.takiSaving = false;
      }
    },
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.onManualWeightKey);
  },

  async mounted() {
    window.addEventListener("keydown", this.onManualWeightKey);
    try {
      const perm = await this.$store.dispatch("inventory/getCanViewSupplierIntakeReconciliation");
      this.canCloseIntake = !!(perm && (perm.canView === true || perm === true));
    } catch (e) {
      this.canCloseIntake = false;
    }
    try {
      const configRes = await apiSettings.getConfig();
      if (configRes.data && configRes.data.hasFiyat != null) {
        this.hasFiyat = parseFloat(configRes.data.hasFiyat) || null;
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn("Config alınamadı:", e);
    }
    await this.loadDefinitions();
    await this.loadSuppliers();
    await this.loadData();
    await this.loadReceivePending();
  },
};
</script>

<style scoped>
.receive-line {
  border: 1px solid #e5e9f0;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 10px;
  background: #fff;
}
.receive-line--done {
  background: #e8f5e9;
  border-color: #a5d6a7;
}
.taki-expected {
  margin-top: 6px;
  padding: 8px 10px;
  border-radius: 6px;
  background: #ede7f6;
  border: 1px solid #d1c4e9;
  color: #4527a0;
  font-size: 12.5px;
  line-height: 1.5;
}
.taki-expected--warn {
  background: #fff3e0;
  border-color: #ffcc80;
  color: #e65100;
}
.rcv-typetoggle { box-shadow: none; border: 1px solid #e0e0e0; border-radius: 6px; overflow: hidden; }
.rcv-typetoggle .v-btn { text-transform: none; margin: 0; font-weight: 600; }
.rcv-type {
  display: inline-block;
  margin-left: 8px;
  padding: 1px 8px;
  border-radius: 4px;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.4px;
  vertical-align: middle;
}
.rcv-type--raf { background: #ede7f6; color: #5e35b1; border: 1px solid #d1c4e9; }
.rcv-type--ato { background: #efebe9; color: #6d4c41; border: 1px solid #d7ccc8; }
.receive-line-title {
  font-size: 17px;
  font-weight: 600;
  color: #263238;
}
.receive-line-meta {
  font-size: 12px;
  color: #78909c;
  margin-top: 2px;
}
.receive-chip {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 4px;
  font-family: Menlo, Consolas, monospace;
  font-size: 11px;
  font-weight: 600;
  vertical-align: middle;
}
.receive-chip--done {
  background: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #c8e6c9;
}
.receive-line--done .receive-chip--done {
  background: #c8e6c9;
}
.receive-chip--wait {
  background: #fff8e1;
  color: #b26a00;
  border: 1px solid #ffe082;
}
.receive-has {
  font-family: Menlo, Consolas, monospace;
  color: #90a4ae;
}
.receive-card {
  border: 1px solid #e5e9f0;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 10px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}
.receive-card:hover {
  border-color: #7e57c2;
  box-shadow: 0 2px 8px rgba(94, 53, 177, 0.18);
}
.receive-card--grey {
  background: #f6f8f9;
  border-color: #cfd8dc;
}
.receive-card--wait {
  background: #fff8e1;
  border-color: #ffe082;
}
.receive-card--red {
  background: #ffebee;
  border-color: #ffcdd2;
}
.receive-card-l {
  min-width: 0;
  padding-right: 12px;
}
.receive-card-items {
  font-size: 12.5px;
  color: #546e7a;
  margin-top: 4px;
}
.receive-chip--grey {
  background: #eceff1;
  color: #546e7a;
  border: 1px solid #cfd8dc;
}
.receive-chip--red {
  background: #ffebee;
  color: #c62828;
  border: 1px solid #ffcdd2;
}
.inv-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}
.inv-actions .inv-btn {
  border-radius: 8px;
  height: 42px;
  min-width: 168px;
  font-weight: 600;
  letter-spacing: 0.4px;
  box-shadow: 0 1px 3px rgba(38, 50, 56, 0.18);
}
.inv-btn-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  margin-left: 8px;
  border-radius: 11px;
  background: #fff;
  color: #5e35b1;
  font-weight: 700;
  font-size: 12px;
}
.receive-btn {
  border-radius: 8px;
  font-weight: 600;
  letter-spacing: 0.4px;
  box-shadow: none;
}

.intake-picker-table {
  width: 100%;
  border-collapse: collapse;
}
.intake-picker-table th,
.intake-picker-table td {
  padding: 6px 10px;
  font-size: 13px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
}
.intake-picker-table th {
  color: rgba(0, 0, 0, 0.54);
  font-weight: 500;
  white-space: nowrap;
}
.intake-picker-table tbody tr {
  cursor: pointer;
}
.intake-picker-table tbody tr:hover {
  background: #e0f2f1;
}
.intake-picker-selected {
  background: #b2dfdb;
}
.intake-picker-table .ta-r {
  text-align: right;
}

.taki-barcode-box {
  border: 1px solid #ccc;
  border-radius: 4px;
}
.taki-barcode-img {
  display: block;
  margin: 4px auto;
}
</style>
